import styled from 'styled-components';

export const Loading = styled.div`
  position: absolute;
  z-index: 2;
  color: #000;
  background: #000;
  opacity: 0.8;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;

export const LoadingText = styled.div`
  position: absolute;
  margin: auto;
  z-index: 3;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100px;
  height: 20px;
  text-align: center;
  border-radius: 3px;
  color: #fff;
`;
